<template>
  <el-dialog :title="options.title"
             :visible.sync="dialogFormVisible"
             custom-class="min-dialog"
             center append-to-body
             :close-on-click-modal="false"
             :modal="true"
             width="300px">
    <CommonTreeView
      ref="deptTree"
      :onlyShowGroupType="options.onlyShowGroupType"
      :canSelectGroupTypeNode="options.canSelectGroupTypeNode"
      :title="options.texts==''?'请选择':options.texts"
      :defaultCheckedKeys="options.ids"
      :needTopNode="false" @check="handleCheck"
      :isShowCheckBox="options.isShowCheckBox"
      :defineDataSource="options.defineDataSource" :useRight="options.useRight" :menuguid="options.menuguid" :fdpath="options.fdpath" @bindData="bindMainData">
    </CommonTreeView>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="confirmSelect()">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {getUsersTree} from '@/api/set/post';
  export default {
    name: "CommTreeViewDialog",
    props: ['options'],
    data() {
      return {
        dialogFormVisible: false,
        defineDataSource:false,
        selectedNodes: [],
        ids:[],//commontreeview中选中值是数组格式
        texts:'',
        guids:"",
      }
    }
    ,
    methods: {
      handleCheck(ids, texts, arr) {
        this.guids = ids;
        this.ids = ids.split(';');
        this.texts = texts;
        this.selectedNodes = arr;
      },
      //确定选择
      confirmSelect() {
        this.$emit("check", this.guids, this.texts, this.selectedNodes, this.options.rowindex);
        this.dialogFormVisible = false;
      },
      bindMainData() {
        if (this.options.showdataType == 'post'&&this.$refs.deptTree) {
          this.$refs.deptTree.bindData(() => {
            return getUsersTree({})
          })
        }else if (this.options.ids.length > 0 && this.$refs.deptTree != undefined) {
          this.$refs.deptTree.bindData();
        }
      },
      showTreeViewDialog() {
        if (this.$refs.deptTree != undefined) {
          this.$refs.deptTree.reset();
        }
        this.ids = this.options.ids;
        this.texts = this.options.texts;

        if (this.options.selectedNodes)
          this.selectedNodes = this.options.selectedNodes;
        this.bindMainData();
        this.dialogFormVisible = true;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/CommTreeViewDialog.vue